<script setup>
defineProps({
  as: {
    type: [Object, String],
    default: 'button',
  },
  type: {
    type: String,
    default: 'button',
  },
  square: {
    type: Boolean,
    default: false,
  },
  insetFocus: {
    type: Boolean,
    default: false,
  },
  external: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <component
    :is="as"
    :type="as === 'button' ? type : null"
    :target="external ? '_blank' : null"
    :class="[
      { rounded: !square },
      insetFocus ? 'focus:ring-inset focus:ring-gray-50' : 'focus:ring-brand-blue-light focus:ring-offset-2',
    ]"
    class="inline-flex items-center justify-center border border-transparent bg-brand-blue px-3 py-2 font-bold text-white hover:bg-brand-blue-dark focus:outline-none focus:ring-2">
    <slot />
  </component>
</template>
